import React, { useState, useCallback } from 'react';
import useURLSearchParams from '../hooks/useURLSearchParams';
import './Tabs.less';

function Tabs({ children }) {
  const [getTabParam, setTabParam] = useURLSearchParams('t');

  const [activeTab, setActiveTab] = useState(getTabParam() || children[0].props.label);

  const handleActiveTabChange = useCallback((label) => {
    setActiveTab(label);
    setTabParam(label);
  }, [setTabParam]);

  const tabs = children.map((child) => (
    <button
      onClick={(e) => {
        e.preventDefault();
        handleActiveTabChange(child.props.label);
      }}
      className={
        child.props.label === activeTab
          ? ['tabs-tab', 'tabs-tab-active'].join(' ')
          : 'tabs-tab'
      }
      key={child.props.label}
    >
      {child.props.tabName}
    </button>
  ));
  const tabContent = children.filter((child) => child.props.label === activeTab);
  return (
    <div>
      <div className="tabs-box">{tabs}</div>
      <div>{tabContent}</div>
    </div>
  );
}

function Tab(props) {
  return <>{props.children}</>;
}

export { Tabs, Tab };
